import { render, staticRenderFns } from "./UrunFotograf.vue?vue&type=template&id=1c2bd95e&"
import script from "./UrunFotograf.vue?vue&type=script&lang=js&"
export * from "./UrunFotograf.vue?vue&type=script&lang=js&"
import style0 from "./UrunFotograf.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports